<div>
  <div class="brand-bar margin-bottom-header"></div>
  <div class="grid align-center margin-top">
    <div class="col-lg-2 ml-2 mr-2">
      <div class="box">
        <h1>Manage Schools Access</h1>
      </div>
    </div>
  </div>
</div>
<div class="grid">
  <div class="col">
    <button
      type="button"
      class="float-right"
      pButton
      label="Download Active User List"
      (click)="exportActiveSchoolUsers()"
      #buttonDownloadActiveUserList
    ></button>
  </div>
</div>
<p-table
  #dt
  [columns]="cols"
  [value]="schools"
  dataKey="schoolId"
  editMode="row"
  class="checkboxSelectionTable align-left"
  [rows]="50"
  [rowsPerPageOptions]="[50, 100, 150]"
  [paginator]="true"
  (sortFunction)="customSort($event)"
  [customSort]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  [showCurrentPageReport]="true"
  selectionMode="single"
  (onPage)="onTablePageSizeChange($event)"
>
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col) {
        <th
          class="align-left"
          [ngStyle]="{ width: col.width }"
          [pSortableColumn]="col.field"
          [pSortableColumnDisabled]="!col.sortable"
          [ariaHidden]="col.header === '' ? true : false"
          [ariaLabel]="col.header"
          scope="col"
        >
          @if (col.sortable) {
            <p-sortIcon [field]="col.field"></p-sortIcon>
          }
          {{ col.header }}
        </th>
      }
    </tr>
    <tr>
      @for (col of columns; track col) {
        <th
          [ngStyle]="{ width: col.width }"
          scope="col"
          [ariaHidden]="
            col.field === 'schoolName' ||
            col.field === 'laId' ||
            col.field === 'schoolNumber' ||
            col.field === 'accessGranted' ||
            col.field === 'principalEmail'
              ? false
              : true
          "
        >
          @switch (col.field) {
            @case ("schoolName") {
              <input
                class="ui-inputtext ui-widget ui-corner-all width-ninety"
                pInputText
                type="text"
                placeholder="Search School name"
                (input)="
                  dt.filter($event.target.value, 'schoolName', 'contains')
                "
              />
            }
            @case ("laId") {
              <input
                class="ui-inputtext ui-widget ui-corner-all width-ninety"
                pInputText
                type="text"
                placeholder="Search LA No."
                (input)="dt.filter($event.target.value, 'laId', 'contains')"
              />
            }
            @case ("schoolNumber") {
              <input
                class="ui-inputtext ui-widget ui-corner-all width-ninety"
                pInputText
                type="text"
                placeholder="Search School No."
                (input)="
                  dt.filter($event.target.value, 'schoolNumber', 'contains')
                "
              />
            }
            @case ("accessGranted") {
              <p-select
                [options]="portalAccess"
                [ngModel]="portalAccess[0].value"
                (onChange)="dt.filter($event.value, col.field, 'equals')"
                appendTo="body"
                #accessGrantDropdown
              ></p-select>
            }
            @case ("principalEmail") {
              <input
                class="ui-inputtext ui-widget ui-corner-all width-ninety"
                pInputText
                type="text"
                placeholder="Search Email"
                (input)="
                  dt.filter($event.target.value, 'principalEmail', 'contains')
                "
              />
            }
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-schools
    let-editing="editing"
    let-ri="rowIndex"
  >
    <tr
      [pEditableRow]="schools"
      class="overflow-wrap"
      [pSelectableRow]="schools"
      (focus)="isFocusOnRow = true"
      (blur)="isFocusOnRow = false"
      (keydown.enter)="editRowData(ri)"
    >
      <td class="table-width-large">{{ schools.schoolName }}</td>
      <td class="table-width-medium">{{ schools.laId }}</td>
      <td class="table-width-medium">{{ schools.schoolNumber }}</td>
      <td class="table-width-medium">
        <a
          href="#"
          id="{{ 'schoolUsers' + schools.schoolId }}"
          title="View users at this school"
          (click)="userDetails(schools, { ri })"
          #schoolUsersLinks
          >{{ schools.schoolUsersCount }}
        </a>
      </td>
      <td class="table-width-large">{{ schools.contactNumber }}</td>
      <td class="table-width-large">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input
              class="full-width"
              pInputText
              type="text"
              [(ngModel)]="schools.principalEmail"
              email
              attr.ri="{{ ri }}"
              required
              #email="ngModel"
              aria-label="Principal email"
            />
            @if (email.invalid && (email.dirty || email.touched)) {
              <div class="error-label">
                @if (email.errors.required) {
                  <div>Email address is required</div>
                }
                @if (email.errors.email) {
                  <div>Provide a valid email address</div>
                }
              </div>
            }
          </ng-template>
          <ng-template pTemplate="output">
            {{ schools.principalEmail }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td class="table-width-medium">
        <p-toggleButton
          onLabel="Revoke"
          (onChange)="changeAccess(schools)"
          offLabel="Grant"
          [(ngModel)]="schools.accessGranted"
        ></p-toggleButton>
      </td>
      <td class="align-center table-width-medium">
        @if (!editing) {
          <button
            pButton
            type="button"
            pInitEditableRow
            icon="pi pi-pencil"
            class="ui-button-info"
            (click)="onRowEditInit(schools, ri)"
            title="Edit Email Address"
          ></button>
        }
        @if (editing) {
          <button
            pButton
            type="button"
            [disabled]="disableSaveButton(schools)"
            pSaveEditableRow
            icon="pi pi-check"
            class="ui-button-success margin-right-custom"
            (click)="onRowEditSave(schools)"
            title="Save Email Address"
          ></button>
        }
        @if (editing) {
          <button
            pButton
            type="button"
            pCancelEditableRow
            icon="pi pi-times"
            class="ui-button-danger"
            (click)="onRowEditCancel(schools)"
            title="Cancel Email Address"
          ></button>
        }
      </td>
      <td class="table-width-small">
        @if (schools.accessGranted && schools.principalEmail !== null) {
          <button
            pButton
            type="button"
            icon="pi pi-envelope"
            title="Resend Welcome Email"
            class="ui-button-info"
            (click)="onSendEmail(schools)"
          ></button>
        }
      </td>
    </tr>
  </ng-template>
</p-table>
<p-confirmDialog></p-confirmDialog>
